import { lazy, Suspense } from 'react'

import Helmet from 'react-helmet'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

export const BUDGET_CATEGORY_CREATE_PAGE = '/settings/budget-categories/create'
export const BUDGETS_CREATE_PAGE = '/settings/budgets/create'

const BudgetCategoryCreateChunk = lazy(() =>
  import('../containers/BudgetCategoryUpsertView').then(
    ({ BudgetCategoryUpsertView }) => ({
      default: BudgetCategoryUpsertView,
    })
  )
)

export const BudgetCategoryCreatePage = () => {
  const intl = useProcurifyIntl()

  return (
    <Suspense fallback={null}>
      <Helmet>
        <title>
          Procurify | {intl.formatMessage(messages.createBudgetTitle)}
        </title>
      </Helmet>
      <BudgetCategoryCreateChunk />
    </Suspense>
  )
}
